import { useMediaQuery } from "react-responsive";
import { InputNumber } from "primereact/inputnumber";
import { Panel } from "primereact/panel";
import { Accordion, AccordionTab } from "primereact/accordion";
import { Fragment, useEffect, useState } from "react";
import "../Investment.scss";
import {
  PURCHASE_PRICE_INITIAL_STATE,
  ASSUMPTION_CONSTANTS,
} from "../investment_constants";
import { getCalculatedPercentage } from "app/utils/utility.service";
import { PMT } from "app/utils/utility.service";
import { Button } from "primereact/button";
import ProfitLoss from "./ProfitLoss";
import Cashflow from "./Cashflow";
import { Link, useLocation } from "react-router-dom";
import { insertLogs } from "../../homepurchase.service";
import AddPropertyInformation from "../../RightContent/Tab1/OwnHouse/PropertyInformation/AddPropertyInformation";
import { NumericFormat } from "react-number-format";
import { getSubscription } from "app/views/subscription/subscription.service";
import { getSessionUserInformation } from "app/utils/utility.service";
import SubscriptionDialog from "app/components/partials/SubscriptionDialog";

const InvestmentAnalysis = ({
  handleInvestmentInputChange,
  assumptionsInput,
  purchasePriceInfo,
  handleInvestmentAnalysisSave,
  leftContentValues,
  handleReportChangeSave
}) => {
  const isDesktopOrLaptop = useMediaQuery({
    query: "(min-width: 1224px)",
  });
  const {state} = useLocation();
  const [addDisable, setAddDisable] = useState(false);
  const [featureModal, setFeatureModal] = useState(false);
  const [isDialog, setIsDialog] = useState(false);
  let sessionValues = getSessionUserInformation();
  const clientId  = state?.clientid; 
  const [propertyInformationModal, setPropertyInformationModal] =
    useState(false);
  const renderFooter = () => {
    return (
      <div>
        <div className="grid">
          <div className="col-6">
            <Button
              label="Save"
              className="p-button-raised p-button-warning p-button-lg"
              onClick={() => handleInvestmentAnalysisSave()}
            />
          </div>
        </div>
      </div>
    );
  };
  useEffect(async () => {
       fetchSubscription();
    }, []);
    const fetchSubscription = async () => {
       let sub = await getSubscription(sessionValues.id);
       let currentPlan = (sub?.subscription_plan?.monthly_price === "0.00" && sub?.subscription_plan?.annual_price === "0.00") && sub?.subscription_plan?.name?.trim()?.toLowerCase() !== "sponsored";
         if(currentPlan) {
            setAddDisable(true);
         } else {
            setAddDisable(false);
         }

    }
  const handlePropertyInformationModal = async () => {
    if(!purchasePriceInfo?.purchasePrice) {
      window.alert("Please provide the purchase price.");
      return;
    }
    if (!propertyInformationModal) {
        await handleInvestmentAnalysisSave();
      const payload = {
        description: "Add Property Information",
      };
      insertLogs(payload);
    }
     if(addDisable) {
          setIsDialog(true);
          setFeatureModal(!featureModal);
      } else {
        setPropertyInformationModal(!propertyInformationModal);
      }
  };
  const renderPropertyInformationModal = () => (
    <AddPropertyInformation
      purchasePriceInfo={purchasePriceInfo}
      propertyInformationModal={propertyInformationModal}
      handlePropertyInformationModal={handlePropertyInformationModal}
      assumptionsInput={assumptionsInput}
    />
  );
    const handleSubscriptionModal = () => {
     
      setFeatureModal(!featureModal);
      setIsDialog(true);
    };
  const renderSubscriptionModal = () => (
      <SubscriptionDialog featureModal={featureModal} 
      handleSubscriptionModal={handleSubscriptionModal}
      isDialog={isDialog}

      />
    );
  const purchasePriceAccordionHeader = () => {
    return (
      <div
        className=""
        onClick={(e) => {
          e.stopPropagation();
          e.preventDefault();
        }}
      >
       
        <h4>Investment</h4>
        <label className="mb-2">Purchase Price</label>
        <div className="p-inputgroup w-90">
          <NumericFormat
            className="input-field"
            style={{"width":"100%"}}
            thousandSeparator=","
            autoComplete="off"
            required={true}
            prefix="$ "
            name="purchasePrice"
            disabled={false}
            allowNegative={false}
            decimalScale={0}
            onBlur={(values) => {
            handleInvestmentInputChange("purchasePrice", values);
            }}
            value={purchasePriceInfo?.purchasePrice}
          />
        </div>
      </div>
    );
  };

  const profitLossAccordionHeader = () => {
    return (
      <div
        className=""
        onClick={(e) => {
          e.stopPropagation();
          e.preventDefault();
        }}
      >
        <hr className="separatorcls"></hr>
        <h4>Profit and Loss</h4>
        <label className="mb-2">Profit / Loss</label>
        <div className="p-inputgroup w-90">
          <NumericFormat
            className="input-field"
            style={{"width":"100%"}}
            thousandSeparator=","
            autoComplete="off"
            required={true}
            prefix="$ "
            name="profitLoss"
            decimalScale={0}
            // onValueChange={handleInvestmentInputChange}
            value={
              purchasePriceInfo?.expenses_profitloss
                ? Math.round(purchasePriceInfo?.expenses_profitloss)
                : 0
            }
          />
        </div>
      </div>
    );
  };

  const cashflowAccordionHeader = () => {
    return (
      <div
        className=""
        onClick={(e) => {
          e.stopPropagation();
          e.preventDefault();
        }}
      >
        <hr className="separatorcls"></hr>
        <h4>Cash Flow</h4>
        <label className="mb-2">Inflow / Outflow</label>
        <div className="p-inputgroup w-90">
          <NumericFormat
            className="input-field"
            style={{"width":"100%"}}
            thousandSeparator=","
            autoComplete="off"
            required={true}
            prefix="$ "
            name="profitLoss"
            decimalScale={0}
            // onValueChange={handleInvestmentInputChange}
            value={purchasePriceInfo?.outflow_positive}
          />
        </div>
      </div>
    );
  };

  const renderInputs = () => {
    return (
      <Fragment>
        <div className="grid">
          <div className="col-6">
            <div className="">
              <label className="mb-2">Principal</label>
              <div className="p-inputgroup">
                <InputNumber
                  className="vw-inputnumber-with-border"
                  style={{"width":"100%"}}
                  thousandSeparator=","
                  autoComplete="off"
                  required={true}
                  prefix="$ "
                  name="mortgage"
                  minFractionDigits={0}
                  maxFractionDigits={0}
                  disabled={true}
                  min={0}
                  // onValueChange={(e) => {
                  //     dispatch(
                  //         changeLeftCalculations({
                  //             name: "purchasePrice",
                  //             value: e.value,
                  //         })
                  //     );
                  //     handleLeftCalculations(
                  //         "purchasePrice",
                  //         e.value
                  //     );
                  // }}
                  value={purchasePriceInfo?.mortgage}
                />
              </div>
            </div>
          </div>

          <div className="col-6">
            <div className="">
              <label className="mb-2">Monthly Rent</label>
              <div className="p-inputgroup">
                <NumericFormat
                  className="input-field"
                  style={{"width":"100%"}}
                  thousandSeparator=","
                  autoComplete="off"
                  required={true}
                  prefix="$ "
                  name="monthlyRent"
                  disabled={false}
                  min={0}
                  decimalScale={0}
                  onBlur={(values) => {
                    handleInvestmentInputChange("monthlyRent", values);
                  }}
                  value={purchasePriceInfo?.monthlyRent}
                />
              </div>
            </div>
          </div>
          <div className="col-6">
            <div className="">
              <label className="mb-2">Down Payment</label>
              <div className="p-inputgroup">
                <InputNumber
                  className="vw-inputnumber-with-border"
                  style={{"width":"100%"}}
                  thousandSeparator=","
                  autoComplete="off"
                  required={true}
                  prefix="$ "
                  name="downPayment"
                  disabled={true}
                  minFractionDigits={0}
                  maxFractionDigits={0}
                  min={0}
                  onBlur={(values) => {
                    handleInvestmentInputChange("downPayment", values);
                  }}
                  value={purchasePriceInfo?.downPayment}
                />
              </div>
            </div>
          </div>
          <div className="col-6">
            <div className="">
              <label className="mb-2">Land</label>
              <div className="p-inputgroup">
                <InputNumber
                  className="vw-inputnumber-with-border"
                  autoComplete="off"
                  required={true}
                  prefix="$ "
                  name="land"
                  disabled={true}
                  minFractionDigits={0}
                  maxFractionDigits={0}
                  // min={0}
                  // onValueChange={(e) => {
                  //     dispatch(
                  //         changeLeftCalculations({
                  //             name: "purchasePrice",
                  //             value: e.value,
                  //         })
                  //     );
                  //     handleLeftCalculations(
                  //         "purchasePrice",
                  //         e.value
                  //     );
                  // }}
                  value={purchasePriceInfo?.land}
                />
              </div>
            </div>
          </div>

          <div className="col-6">
            <div className="">
              <label className="mb-2">Improvement</label>
              <div className="p-inputgroup">
                <InputNumber
                  className="vw-inputnumber-with-border"
                  autoComplete="off"
                  required={true}
                  prefix="$ "
                  name="improvement"
                  disabled={true}
                  minFractionDigits={0}
                  maxFractionDigits={0}
                  // onValueChange={(e) => {
                  //     dispatch(
                  //         changeLeftCalculations({
                  //             name: "purchasePrice",
                  //             value: e.value,
                  //         })
                  //     );
                  //     handleLeftCalculations(
                  //         "purchasePrice",
                  //         e.value
                  //     );
                  // }}
                  value={purchasePriceInfo?.improvement}
                />
              </div>
            </div>
          </div>

          <div className="col-6">
            <div className="">
              <label className="mb-2">Interest Rate</label>
              <div className="p-inputgroup">
                <InputNumber
                  className="vw-inputnumber-with-border"
                  autoComplete="off"
                  required={true}
                  suffix=" %"
                  name="interestRate"
                  minFractionDigits={2}
                  maxFractionDigits={2}
                  disabled={true}
                  min={0}
                  // onValueChange={(e) => {
                  //     dispatch(
                  //         changeLeftCalculations({
                  //             name: "purchasePrice",
                  //             value: e.value,
                  //         })
                  //     );
                  //     handleLeftCalculations(
                  //         "purchasePrice",
                  //         e.value
                  //     );
                  // }}
                  value={purchasePriceInfo?.interestRate}
                />
              </div>
            </div>
          </div>

          <div className="col-6">
            <div className="">
              <label className="mb-2">Mortgage</label>
              <div className="p-inputgroup">
                <InputNumber
                  className="vw-inputnumber-with-border"
                  autoComplete="off"
                  required={true}
                  prefix="$ "
                  minFractionDigits={0}
                  maxFractionDigits={0}
                  name="monthlyMortgage"
                  disabled={true}
                  // onValueChange={(e) => {
                  //     dispatch(
                  //         changeLeftCalculations({
                  //             name: "purchasePrice",
                  //             value: e.value,
                  //         })
                  //     );
                  //     handleLeftCalculations(
                  //         "purchasePrice",
                  //         e.value
                  //     );
                  // }}
                  value={purchasePriceInfo?.monthlyMortgage}
                />
              </div>
            </div>
          </div>

          <div className="col-6">
            <div className="">
              <label className="mb-2">Interest</label>
              <div className="p-inputgroup">
                <InputNumber
                  className="vw-inputnumber-with-border"
                  autoComplete="off"
                  required={true}
                  prefix="$ "
                  name="interestAmount"
                  minFractionDigits={0}
                  maxFractionDigits={0}
                  disabled={true}
                  // onValueChange={(e) => {
                  //     dispatch(
                  //         changeLeftCalculations({
                  //             name: "purchasePrice",
                  //             value: e.value,
                  //         })
                  //     );
                  //     handleLeftCalculations(
                  //         "purchasePrice",
                  //         e.value
                  //     );
                  // }}
                  value={purchasePriceInfo?.interestAmount}
                />
              </div>
            </div>
          </div>

          <div className="col-6">
            <div className="">
              <label className="mb-2">Property Taxes</label>
              <div className="p-inputgroup">
                <InputNumber
                  className="vw-inputnumber-with-border"
                  autoComplete="off"
                  required={true}
                  prefix="$ "
                  name="propertyTaxes"
                  disabled={true}
                  minFractionDigits={0}
                  maxFractionDigits={0}
                  // onValueChange={(e) => {
                  //     dispatch(
                  //         changeLeftCalculations({
                  //             name: "purchasePrice",
                  //             value: e.value,
                  //         })
                  //     );
                  //     handleLeftCalculations(
                  //         "purchasePrice",
                  //         e.value
                  //     );
                  // }}
                  value={purchasePriceInfo?.propertyTaxes}
                />
              </div>
            </div>
          </div>

          <div className="col-6">
            <div className="">
              <label className="mb-2">Maintenance</label>
              <div className="p-inputgroup">
                <InputNumber
                  className="vw-inputnumber-with-border"
                  autoComplete="off"
                  required={true}
                  prefix="$ "
                  name="maintenance"
                  disabled={true}
                  minFractionDigits={0}
                  maxFractionDigits={0}
                  // onValueChange={(e) => {
                  //     dispatch(
                  //         changeLeftCalculations({
                  //             name: "purchasePrice",
                  //             value: e.value,
                  //         })
                  //     );
                  //     handleLeftCalculations(
                  //         "purchasePrice",
                  //         e.value
                  //     );
                  // }}
                  value={purchasePriceInfo?.maintenance}
                />
              </div>
            </div>
          </div>
        </div>
      </Fragment>
    );
  };

  return (
    <div className="InvestmentAnalysis">
       <div>
          <a
                href="javascript:;"
                style={{"fontWeight":"normal","marginLeft":"54rem"}}
                onClick={()=>handleReportChangeSave(clientId, true, 'capital-growth-estimation')}
                className={`${
                    isDesktopOrLaptop
                        ? "mr-5"
                        : "mr-4"
                }`}
            >
                Go To Growth View
            </a>
        </div>
      <Accordion
        className=""
        expandIcon={<i className="pi pi-plus"></i>}
        collapseIcon={<i className="pi pi-minus"></i>}
      >
        <AccordionTab header={purchasePriceAccordionHeader()}>
          {renderInputs()}
        </AccordionTab>
        <AccordionTab header={profitLossAccordionHeader()}>
          <ProfitLoss
            purchasePriceInfo={purchasePriceInfo}
            handleInvestmentInputChange={handleInvestmentInputChange}
          />
        </AccordionTab>
        <AccordionTab header={cashflowAccordionHeader()}>
          <Cashflow
            purchasePriceInfo={purchasePriceInfo}
            handleInvestmentInputChange={handleInvestmentInputChange}
          />

          
        </AccordionTab>
      </Accordion>
     
      <div className="flex" style={{alignItems:"center"}}>
    
      <div className="col-3" >
            <Button
              label="Save" style={{marginLeft:"10.5rem"}}
              className="p-button-raised p-button-warning p-button-lg"
              onClick={() => handleInvestmentAnalysisSave()}
            />
          </div>
        
        <div className="col-2 text-align-center">
          <Button
            label="Add"
           style={{marginLeft:"3.5rem"}}
            className={`p-button-raised p-button-warning ${
              isDesktopOrLaptop ? "p-button-lg" : "margin-top-button save-width"
            }`}
            onClick={handlePropertyInformationModal}
          />
        </div>
       
      </div>
      {propertyInformationModal && renderPropertyInformationModal()}
       {featureModal && renderSubscriptionModal()}
      <Panel className="mb-2 OwnHouse">
        <div
        // className={`${
        //     isDesktopOrLaptop ? "align-text" : "align-text-left"
        // }`}
        ></div>
      </Panel>
      {!isDesktopOrLaptop && (
        <div className="text-align-center">
          <Link to="/home-purchase/step3/tab1">Home</Link>
        </div>
      )}
    </div>
  );
};

export default InvestmentAnalysis;
